import React, { useState, useEffect } from 'react';
import { Redirect, Link } from "react-router-dom";
import { Layout, Typography, Form, Input, Button, Checkbox, notification } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import _auth from '@netuno/auth-client';

import RecoverModal from './RecoverModal';

import './index.less';

const { Title } = Typography;
const { Content, Sider } = Layout;

const langContext = 'login';

export default function Login(props) {

    const [submitting, setSubmitting] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (_auth.isLogged()) {
            window.scrollTo(0, 0);
        }
        window.scrollTo(0, 0);
    });

    const intl = useIntl();

    function onFinish(values) {
        setSubmitting(true);
        const { username, password, remember } = values;
        if (remember) {
            localStorage.setItem("login", JSON.stringify(values));
        } else {
            localStorage.removeItem("login");
        }
        _auth.login({
            username,
            password,
            success: () => {
                setSubmitting(false);
            },
            fail: () => {
                setSubmitting(false);
                notification["error"]({
                    message: 'Login Inválido',
                    description:
                        'Por favor verifique as credenciais inseridas.',
                });
            }
        });
    }

    function onFinishFailed(errorInfo) {
        console.log('Failed:', errorInfo);
    }

    let initialValues = { remember: true };
    if (localStorage.getItem("login") != null) {
        initialValues = JSON.parse(localStorage.getItem("login"));
    }

    if (_auth.isLogged()) {
        return <Redirect to="/marketplace/waste" />;
    } else {
        return (
            <Layout>
                <Content className="login-container">
                    <div className="content-title">
                        <Title><FormattedMessage id={`${langContext}.title`} /></Title>
                    </div>
                    <div className="content-body">
                        <p>{intl.formatMessage({ id: 'login.content-body' })}</p>
                        <Form
                            layout="vertical"
                            name="basic"
                            initialValues={initialValues}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item
                                label={intl.formatMessage({ id: 'login.fields.username' })}
                                name="username"
                                rules={[{ required: true, message: 'Insira o seu utilizador.' }]}
                            >
                                <Input loading={submitting} />
                            </Form.Item>

                            <Form.Item
                                label={intl.formatMessage({ id: 'login.fields.password' })}
                                name="password"
                                rules={[{ required: true, message: 'Insira a palavra-passe.' }]}
                            >
                                <Input.Password loading={submitting} />
                            </Form.Item>

                            <Form.Item name="remember" valuePropName="checked">
                                <Checkbox>{intl.formatMessage({ id: 'login.fields.remember' })}</Checkbox>
                            </Form.Item>

                            <Form.Item>
                                <Button loading={submitting} type="primary" className="login-btn" htmlType="submit">
                                    <FormattedMessage id={`${langContext}.button.login`} />
                                </Button>
                            </Form.Item>

                            <Form.Item style={{ textAlign: 'center' }}>
                                <Button type="link" onClick={() => setVisible(!visible)} >{intl.formatMessage({ id: 'login.fields.forgot-password' })}?</Button>
                                {visible && <RecoverModal onClose={() => { setVisible(false) }} />}
                            </Form.Item>

                            <hr />
                            <span><p>{intl.formatMessage({ id: 'login.fields.or' })}</p></span>
                            <Link to="/register">
                                <Button loading={submitting} type="default" className={"register-btn"}>
                                    <FormattedMessage id={`${langContext}.button.create`} />
                                </Button>
                            </Link>
                        </Form>
                    </div>

                </Content>
                <Sider width={'50%'} style = {{'position':'relative'}}>
                    <span class="helper" /><img style = {{'position':'fixed', 'top':'50%', 'transform':'translate(0%,-50%)', 'right':0, 'width':'50%'}} alt="sider-login" src={"/images/Background_home.svg"} />
                </Sider>
            </Layout>
        );
    }

}
